import { Card, Col, Form, message, Row, Space, Typography } from "antd";
import { AntdButton, InputField, SelectInput, TextareaField } from "../../../blueplanitUtils/InputField";
import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddCandidateDetailsAsync, getCandidateListAsync } from "../../../Slices/hiringSlice";

const AddCandidate = ({ setOpen }) => {
    const fileInputRef = useRef(null);
    const [resumeFiles, setResumeFiles] = useState(null);
    const [resumeFilename, setResumeFilename] = useState("");
    const [resumeBase64, setResumeBase64] = useState("");

    const details = useSelector((state) => state.employee.AllEmployees);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);


    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        currentRole: '',
        currentCTC: '',
        expectedCTC: '',
        releventExperience: '',
        totalExperience: '',
        availability: '',
        department: '',
        status: '',
        source: '',
        jobTitle: '',
        experience: '',
        assignedRecruiter: '',
        resumeUrl: '',
        resumeFilename: ''
    })

    const handleChange = (key, value) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value
        }
        ))
    };

    const assignedToOptions = details.map((emp) => ({
        label: emp.firstname + " " + emp.lastname,
        value: emp.id,
    }));

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setResumeFiles(file);
        setResumeFilename(file.name);

        const reader = new FileReader();
        reader.onload = () => setResumeBase64(reader.result);
        reader.readAsDataURL(file);
    };


    const handleSubmit = async () => {
        try {
            const payload = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                currentRole: formData.currentRole,
                currentCTC: formData.currentCTC,
                expectedCTC: formData.expectedCTC,
                availability: formData.availability,
                department: formData.department,
                releventExperience: formData.releventExperience,
                totalExperience: formData.totalExperience,
                source: formData.source,
                status: formData.status,
                jobTitle: formData.jobTitle,
                experience: formData.experience,
                assignedRecruiter: formData.assignedRecruiter,
                resumeUrl: resumeBase64,
                resumeFilename: resumeFilename,
                createdBy: loginUser.firstname + " " + loginUser.lastname,
            };

            await dispatch(AddCandidateDetailsAsync(payload)).unwrap();
            message.success('Candidate added successfully');
            await dispatch(getCandidateListAsync())

        } catch (error) {
            const errorMessage = error?.message || "Failed to create candidate";

            if (errorMessage === "Candidate has already applied for this job") {
                message.warning(errorMessage);
            } else {
                message.error(errorMessage);
            }
        }


    };


    return (
        <div>
            <Row justify="end" gutter={16} style={{ marginBottom: "7px" }}>
                <Col span={24} style={{ marginTop: 16, textAlign: "right" }}>
                    <Space>
                        <AntdButton label="Submit" color='primary' variant='solid' htmlType="submit" onClick={handleSubmit} />

                        <AntdButton label="Close" color='danger' variant='solid' onClick={() => setOpen(false)} />

                    </Space>
                </Col>
            </Row>
            <Card
                style={{ marginBottom: "12px" }}
                title={
                    <Space
                        direction="horizontal"
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography.Title
                            level={5}
                            style={{ marginBottom: 0, fontWeight: "bold" }}
                        >
                            Add Candidate
                        </Typography.Title>
                    </Space>
                }
            >
                <Row gutter={[16, 16]}>
                    <Col span={4}>
                        <InputField
                            label="First Name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={(e) => handleChange('firstName', e.target.value)}
                            placeholder="Enter FirstName"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={(e) => handleChange('lastName', e.target.value)}
                            placeholder="Enter LastName"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={(e) => handleChange('email', e.target.value)}
                            placeholder="Enter Email-ID"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Phone.No"
                            name="phone"
                            value={formData.phone}
                            onChange={(e) => handleChange('phone', e.target.value)}
                            placeholder="Enter Phone.No"
                        />
                    </Col>
                    <Col span={4}>
                        <SelectInput
                            label="Source"
                            name="source"
                            placeholder="Select Source"
                            value={formData.source}
                            onChange={(value) => handleChange("source", value)}
                            options={[
                                { label: "LinkedIn", value: "LinkedIn" },
                                { label: "Indeed", value: "Indeed" },
                                { label: "Referal", value: "Referal" },
                                { label: "Walk_In", value: "Walk_In" }
                            ]}
                            style={{ width: "100%" }}
                        />
                    </Col>

                    <Col span={4}>
                        <label style={{ display: "block", marginBottom: "10px", fontWeight: "500" }}>
                            Upload Resume
                        </label>

                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept=".pdf,.doc,.docx"
                            onChange={handleFileChange}
                        />

                        <Link
                            onClick={() => fileInputRef.current.click()}
                            style={{ cursor: "pointer" }}
                        >
                            <i
                                className="fa-solid fa-file"
                                style={{ fontSize: "20px", marginRight: "10px" }}
                            />
                            Choose File
                        </Link>


                        {resumeBase64 && (
                            <a href={resumeBase64} target="_blank" rel="noopener noreferrer">
                                {resumeFilename}
                            </a>
                        )}


                    </Col>

                    <Col span={4}>
                        <InputField
                            label="Current Role"
                            name="currentRole"
                            value={formData.currentRole}
                            onChange={(e) => handleChange('currentRole', e.target.value)}
                            placeholder="Enter Current Role"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Applied Role"
                            name="jobTitle"
                            value={formData.jobTitle}
                            onChange={(e) => handleChange('jobTitle', e.target.value)}
                            placeholder="Enter Applied Role"
                        />
                    </Col>
                    <Col span={4}>
                        <SelectInput
                            label="Department"
                            name="department"
                            value={formData.department}
                            onChange={(value) => handleChange("department", value)}
                            placeholder="Select Department"
                            style={{ width: "100%" }}
                            options={[
                                { label: "Sales & Marketing", value: "Sales & Marketing" },
                                { label: "Insurance Operations", value: "Insurance Operations" },
                                { label: "HR & Admin", value: "HR & Admin" },
                                { label: "Information Technology", value: "Information Technology" },
                                { label: "Networking & Cyber Security", value: "Networking & Cyber Security" }]}
                        />
                    </Col>

                    <Col span={4}>
                        <InputField
                            label="Relevant Experience"
                            name="releventExperience"
                            value={formData.releventExperience}
                            onChange={(e) => handleChange('releventExperience', e.target.value)}
                            placeholder="Enter Relevant Experience"
                        />
                    </Col>

                    <Col span={4}>
                        <InputField
                            label="Total Experience"
                            name="experience"
                            value={formData.experience}
                            onChange={(e) => handleChange('experience', e.target.value)}
                            placeholder="Enter Total Experience"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Current CTC"
                            name="currentCTC"
                            value={formData.currentCTC}
                            onChange={(e) => handleChange('currentCTC', e.target.value)}
                            placeholder="Enter Current CTC"
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Expected CTC"
                            name="expectedCTC"
                            value={formData.expectedCTC}
                            onChange={(e) => handleChange('expectedCTC', e.target.value)}
                            placeholder="Enter Expected CTC"
                        />
                    </Col>
                    <Col span={4}>
                        <SelectInput
                            label="Availability"
                            name="availability"
                            value={formData.availability}
                            onChange={(value) => handleChange('availability', value)}
                            placeholder="Select Availability"
                            options={[
                                { label: "Immediately", value: "Immediately" },
                                { label: "Lessthan 15 days", value: "Lessthan 15 days" },
                                { label: "30days", value: "30days" }
                            ]}
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col span={4}>
                        <SelectInput
                            label="Shift Preference"
                            name="shiftpreference"
                            placeholder="Select Shift Preference"
                            style={{ width: "100%" }}
                            options={[
                                { label: "General", value: "General" },
                                { label: "Morning", value: "Morning" },
                                { label: "Evening", value: "Evening" },
                                { label: "Night", value: "Night" },
                                { label: "Rotational", value: "Rotational" }
                            ]}
                        />
                    </Col>
                    <Col span={4}>
                        <InputField
                            label="Skill Tags"
                            name="skilltags"
                            type="tags"
                            value={formData.skill}
                            placeholder="Select Skill Tags"
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col span={4}>
                        <SelectInput
                            label="Status"
                            name="status"
                            placeholder="Select Status"
                            value={formData.status}
                            onChange={(value) => handleChange("status", value)}
                            options={[
                                { label: "Applied", value: "Applied" },
                                { label: "Selected", value: "Selected" },
                                { label: "On Hold", value: "On Hold" },
                                { label: "Rejected", value: "Rejected" },
                                { label: "Future Consideration", value: "Future Consideration" },
                                { label: "Rejected", value: "Rejected" }
                            ]}
                            style={{ width: "100%" }}
                        />
                    </Col>

                    <Col span={4}>
                        <SelectInput
                            label="Assigned Recruiter"
                            name="assignedRecruiter"
                            value={formData.assignedRecruiter}
                            onChange={(value) => handleChange("assignedRecruiter", value)}
                            style={{ width: "100%" }}
                            options={assignedToOptions}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                            placeholder="Select Assigned Recruiter"

                        />
                    </Col>

                    <Col span={24}>
                        <TextareaField
                            label="Remarks"
                            name="remarks"
                            rows={3}
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
};

export default AddCandidate